import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n          transform: scale(1);\n          visibility: visible;\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n          transition: 0.25s;\n          transform: scale(0.4);\n          opacity: 0;\n          visibility: hidden;\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  position: relative;\n  border-radius: 12px;\n  background-color: #fff;\n  color: #222;\n  ",
        "\n  //max-width: 90%;\n	max-height: 100%;\n  margin: 0 auto;\n  transition: 0.3s;\n  will-change: transform;\n  overflow: hidden;\n  @media (max-width: 1200px) {\n    ",
        "\n  }\n  ",
        ";\n  header {\n    position: relative;\n    justify-content: space-between;\n    padding: 0 16px;\n    height: 44px;\n    border-bottom: 1px solid #e3e3e3;\n    background-color: #fff;\n\n    h4 {\n      text-align: center;\n      line-height: 44px;\n      margin-bottom: 0;\n    }\n\n    button {\n      position: absolute;\n      top: 10px;\n      right: 15px;\n    }\n  }\n\n  > div {\n    overflow: auto;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  padding: 40px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  margin-top: 24px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  text-align: center;\n  padding-bottom: 24px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Overlay, { OverlayClose, useCloseOverlay } from "../common/Overlay";
import styled, { css } from "styled-components";
const Modal = (param)=>{
    let { title , width , children , modalBgColor , ...props } = param;
    const { open  } = props;
    return /*#__PURE__*/ _jsx(StyledOverlay, {
        ...props,
        children: /*#__PURE__*/ _jsxs(StyledDiv, {
            open: open,
            width: width,
            style: {
                backgroundColor: modalBgColor
            },
            children: [
                title && /*#__PURE__*/ _jsxs("header", {
                    children: [
                        /*#__PURE__*/ _jsx("h4", {
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(OverlayClose, {
                            ...props
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: children
                })
            ]
        })
    });
};
export default Modal;
const StyledDiv = styled.div.withConfig({
    componentId: "sc-ad535ec3-0"
})(_templateObject2(), (param)=>{
    let { width  } = param;
    return width && "width: ".concat(width, "px;");
}, (param)=>{
    let { width  } = param;
    return width && "width: ".concat(width, "px;");
}, (param)=>{
    let { open  } = param;
    return open ? css(_templateObject()) : css(_templateObject1());
});
const StyledOverlay = styled(Overlay).withConfig({
    componentId: "sc-ad535ec3-1"
})(_templateObject3());
export const ModalButton = (param)=>{
    let { onClick , ...props } = param;
    const closeOverlay = useCloseOverlay();
    return /*#__PURE__*/ _jsx(StyledModalButton, {
        children: /*#__PURE__*/ _jsx("button", {
            ...props,
            onClick: onClick !== null && onClick !== void 0 ? onClick : ()=>closeOverlay()
        })
    });
};
const StyledModalButton = styled.div.withConfig({
    componentId: "sc-ad535ec3-2"
})(_templateObject4());
export const ModalTitle = (param)=>{
    let { text  } = param;
    return /*#__PURE__*/ _jsx(StyledModal, {
        className: "multiline",
        children: text
    });
};
const StyledModal = styled.h4.withConfig({
    componentId: "sc-ad535ec3-3"
})(_templateObject5());
